import { NotificationsApiFactory } from '@eloomi/eloomi-notifications-persona-client/1.0';
import { authorizeClient } from '@/api/authorize-client';

export const notificationsClient = authorizeClient(NotificationsApiFactory);
